import gql from 'graphql-tag';

export const CARBON_EMISSIONS_REQUEST_REPROCESSING = gql`
  mutation carbonEmissionsRequestReprocessing($scenarioId: Int , $startTime: DateTimeOffset, $endTime: DateTimeOffset) {
    carbonEmissionsRequestReprocessing(scenarioId: $scenarioId, startTime: $startTime, endTime: $endTime)
  }
`;